import {EditorComponentsRendering} from "./core/EditorComponentsRendering.js";
import {FroalaInit} from "./core/FroalaInit.js";
import {readContainer} from "./core/ConvertToJson.js";
import {fetchRequestSend} from "../helpers/common-helpers";
import l10n from '../lang/locallang';
export class CGEditorTopic {
    static hasChanges = false;

    static run() {
        window.addEventListener('click', CGEditorTopic.openExistingArticle);
        window.addEventListener('click', CGEditorTopic.openNewArticle);
        window.addEventListener('click', CGEditorTopic.saveLessonButton);
        CGEditorTopic.openLessonFromURL();
    }
    static openExistingArticle(e) {
        let button = e.target.closest('.open-editor-article');
        if(button){
            e.preventDefault();
            let topicID = button.closest('.tr-course-progress').dataset.lesson;
            CGEditorTopic.createPreloader();
            CGEditorTopic.openLessonMain(null, topicID);
            CGEditorTopic.closeEditorPopup();
            CGEditorTopic.setParamsToURL(topicID);
            CGEditorTopic.setTitle(topicID);
            CGEditorTopic.hasLessonChanges();
        }
        return;
    }
    static openNewArticle(e) {
        let button = e.target.closest('.lesson-type-btn');
        if(button){
            e.preventDefault();
            if(button.dataset.value === 'cgeditor' || button.dataset.value === 'cgeditor_ai'|| button.dataset.value === 'cgeditor_ai_2'|| button.dataset.value === 'cgeditor_ai_3'){
                let lesson_name = button.closest('.custom-lesson').querySelector('.custom-lesson-title_inp').value;
                let course_name = document.getElementsByName('course-title')[0].value;
                let lesson_id = button.closest('.custom-lesson').dataset.lesson;
                //console.log(lesson_name, course_name);
                let topicID;
                if(button.closest('.tr-course-progress')){
                    topicID = button.closest('.tr-course-progress').dataset.lesson;
                }

                if(button.closest('#assistant_popup_prompt')){
                    topicID = button.closest('#assistant_popup_prompt').dataset.lesson;
                }

                // if it's _ai or _ai_2 or _ai_3 then run AI content
                if(button.dataset.value === 'cgeditor_ai' || button.dataset.value === 'cgeditor_ai_2' || button.dataset.value === 'cgeditor_ai_3'){
                    if(button.dataset.value === 'cgeditor_ai'){
                        //aiContent.requestForAILesson(lesson_name, course_name, lesson_id);
                    }
                    if(button.dataset.value === 'cgeditor_ai_2'){
                        console.log('AI 2')
                    }
                    if(button.dataset.value === 'cgeditor_ai_3') {
                        console.log('AI 3')
                    }
                }

                //CGEditorTopic.createPreloader();
                CGEditorTopic.openLessonMain(null, topicID);
                CGEditorTopic.closeEditorPopup();
                CGEditorTopic.setParamsToURL(topicID);
                CGEditorTopic.setTitle(topicID);
                CGEditorTopic.hasLessonChanges();
            }
        }
        return;
    }
    static init(button) {
        console.log(button)
        const topicID = button.dataset.lesson;
        CGEditorTopic.closeEditorPopup();
        // set URL params
        CGEditorTopic.setParamsToURL(topicID);
        // check is CGEditorTopic. new topic tutorial or editing
        if(button.classList.contains('lesson-type-btn')){
            CGEditorTopic.openLessonMain(button);
            setTimeout(() => {
                CGEditorTopic.createNewEditor(button);
            }, 100);
        }
    }

    static setTitle(topicID) {
        let editorPopup = document.querySelector('.editor-popup');
        const topicElement = document.querySelector(`.custom-lesson[data-lesson="${topicID}"]`);
        const topicTitle = topicElement.querySelector('.custom-lesson-title_inp').value;
        editorPopup.querySelector('.editor-heading_lesson-name').innerHTML = topicTitle;
    }
    static previewEditorArticle() {
        window.addEventListener('click', (e) => {
            let button = e.target.closest('.open-editor-article');
            if(button){
                e.preventDefault();
                let topicID = button.closest('.tr-course-progress').dataset.lesson;
                CGEditorTopic.openLessonMain(null, topicID);
            }
        });
    }
    static setParamsToURL(topicID, revert = false) {
        if(revert){
            // remove params from URL
            window.history.pushState('', '', '?');
            return;
        }
        window.history.pushState('', '', '?topic=' + topicID + '&mode=editor');
    }
    static createNewEditor(button) {
        console.log(button)
        //set data-is-new to true to popup editor-popup
        let editorPopup = document.querySelector('.editor-popup');
        editorPopup.dataset.isNew = true;
        // set .editor-heading_lesson-name to topic name
        const topicID = button.dataset.lesson;
        const topicElement = document.querySelector(`.custom-lesson[data-lesson="${topicID}"]`);
        const topicTitle = topicElement.querySelector('.custom-lesson-title_inp').value;
        //console.log(editorPopup, topicTitle)
        editorPopup.querySelector('.editor-heading_lesson-name').innerHTML = topicTitle;
    }
    static openLessonFromURL() {
        let url = new URL(window.location.href);
        let topic = url.searchParams.get("topic");
        let mode = url.searchParams.get("mode");
        if(topic && mode){
            if(mode === 'editor') {
                CGEditorTopic.createPreloader();
                CGEditorTopic.openLessonMain(null, topic);
                CGEditorTopic.closeEditorPopup();
                CGEditorTopic.setParamsToURL(topic);
                CGEditorTopic.setTitle(topic);
            }
        }
    }
    static openLessonMain(button = null, lesson_id = null) {
        //document.body.classList.add('loading');
        const popup = document.querySelector('.editor-popup');
        if(button) {
            popup.dataset.lesson = lesson_id;
            //set body class for popup
            document.body.classList.add('editor-popup-open');
            setTimeout(() => {
                popup.classList.add('show');
            });

        } else {
            document.body.classList.add('editor-popup-open');
            setTimeout(() => {
                popup.classList.add('show');
            });
            CGEditorTopic.fetchLessonContent(lesson_id);
        }
    }
    static closeEditorPopup() {
        window.addEventListener('click', (e) => {
            const button = e.target.closest('.editor-close-button');
            if (button) {
                e.preventDefault();
                // remove body class for popup

                if(CGEditorTopic.hasChanges === false){
                    CGEditorTopic.closeEditorPopupAction();
                } else {
                    CGEditorTopic.popupConfirmClose();
                }

                // disable
                //
                // const toolbar = document.querySelectorAll('.fr-toolbar');
                // setTimeout(() => {
                //     console.log(toolbar)
                //     if(toolbar.length){
                //         toolbar.forEach((el) => {
                //             // remove top position
                //             el.style.top = '';
                //             el.style.left = '';
                //             el.style.right = '';
                //             el.style.bottom = '';
                //         });
                //     }
                // }, 100);

                // create new global event for this action
                const event = new CustomEvent('closeEditorPopup');
                document.dispatchEvent(event);

                //location.reload();

            }
        });
    }
    static closeEditorPopupAction(){
        const popup = document.querySelector('.editor-popup');
        popup.classList.remove('show');
        document.body.classList.remove('editor-popup-open');
        if(popup.classList.contains('save-new-lesson')){
            popup.classList.remove('save-new-lesson')
        }
        const editorWorkplace = document.querySelector('.editor-workplace');
        editorWorkplace.innerHTML = '';
        if(popup.querySelector('.btn-add-first.hidden')){
            popup.querySelector('.btn-add-first.hidden').classList.remove('hidden');
        }
        CGEditorTopic.hasChanges = false;
        CGEditorTopic.setParamsToURL('', true);
        CGEditorTopic.stopPreloader();
        // clean editor-ai-text__text
        if(document.querySelector('.editor-ai-text__text')){
            document.querySelector('.editor-ai-text__text').innerHTML = '';
        }

        //window.history.pushState('', '', '/editor/');
    }

    static fetchLessonContent(lesson_id) {
        let json_content = JSON.stringify({'topic_id': lesson_id});
        if(!getLessonContentURL || getLessonContentURL === undefined){
            let getLessonContentURL = '';
        }
        fetchRequestSend(getLessonContentURL, 'POST', json_content).then(r => {
            //console.log(r.content)
            CGEditorTopic.renderLessonContent(r.content);
            setTimeout(() => {
                if(document.getElementById('editor-main').children.length > 0){
                    document.querySelector('.btn-add-first').classList.add('hidden');
                } else {
                    document.querySelector('.btn-add-first').classList.remove('hidden');
                }
            }, 1000);
            CGEditorTopic.stopPreloader();
        });
    }

    static hasLessonChanges() {
        window.addEventListener('click', (e) => {
            let btnAddComponent = e.target.closest('.add-editor-section');
            if(btnAddComponent){
                if(!btnAddComponent.classList.contains('ai-component-item')){
                    console.log('add component');
                    CGEditorTopic.hasChanges = true;
                }
            }
        });
    }
    static popupConfirmClose() {
        const { wantSaveChanges, yesISaveIt, noDontSave } = l10n.editor;
        let popup_element = document.querySelector('.popup-confirm-close');
        if(!popup_element){
            const popup = document.createElement('div');
            popup.classList.add('popup-confirm-close');
            popup.innerHTML = `
                    <a href="#" class="popup-confirm-close_exit"><i class="icon-close-small"></i></a>
                    <div class="popup-confirm-close__content">${wantSaveChanges}?</div>
                    <div class="popup-confirm-close__buttons">
                        <button class="btn btn-primary btn-sm popup-confirm-close__button popup-confirm-close__button--yes">${yesISaveIt}</button>
                        <button class="btn btn-primary btn-sm popup-confirm-close__button popup-confirm-close__button--no">${noDontSave}</button>
                    </div>
                `;
            document.body.appendChild(popup);
            setTimeout(() => {
                popup.classList.add('show');
                document.body.classList.add('__has-overflow');
            }, 100);

            CGEditorTopic.popupConfirmCloseAction();
            CGEditorTopic.popupConfirmClosePopup();
        } else {
            document.body.classList.add('__has-overflow');
        }
    }
    static popupConfirmCloseAction() {
        window.addEventListener('click', (e) => {
            const button = e.target.closest('.popup-confirm-close__button');
            if(button){
                if(button.classList.contains('popup-confirm-close__button--yes')){
                    CGEditorTopic.saveLesson();
                    CGEditorTopic.closeEditorPopupAction();
                    CGEditorTopic.popupConfirmClosePopup(button);
                } else {
                    CGEditorTopic.closeEditorPopupAction();
                    CGEditorTopic.popupConfirmClosePopup(button);
                }

            }

            const close_button = e.target.closest('.popup-confirm-close_exit');
            if(close_button){
                CGEditorTopic.popupConfirmClosePopup(close_button);
            }
        });
    }
    static popupConfirmClosePopup(button){
        if(document.querySelector('.popup-confirm-close')){
            document.body.classList.remove('__has-overflow');
            button.closest('.popup-confirm-close').classList.remove('show');
            setTimeout(() => {
                document.querySelector('.popup-confirm-close').remove();
            }, 100);
        }
    }
    static saveLessonButton(e) {
        const button = e.target.closest('#editor-save-button');
        if(button){

            CGEditorTopic.createPreloader();
            CGEditorTopic.saveLesson(button);
        }
    }
    static createPreloader() {

        let preloader = document.createElement('div');
        preloader.classList.add('save-preloader');
        document.body.appendChild(preloader);
        setTimeout(() => {
            document.body.classList.add('loading');
        }, 200);
    }
    static stopPreloader() {
        document.body.classList.remove('loading');
        setTimeout(() => {
            if(document.querySelector('.save-preloader')){
                document.querySelector('.save-preloader').remove();
            }
        }, 200)
    }
    /*
    * Function for saving lesson content
    * @param button - button element
    * @param component - component element, if it is null, then save full lesson, if not null, then save only component
    * */
    static saveLesson (button = null, component = null){
        const { savingProcess, saved, saveLesson } = l10n.editor;

        if(!button){
            button = document.querySelector('#editor-save-button');
        }
        button.innerText = `${savingProcess}...`;
        const editorContent = document.querySelector('.editor-body');
        const popup = document.querySelector('.editor-popup');
        if(editorContent) {
            CGEditorTopic.hasChanges = false;
            if(typeof saveLessonContentURL !== 'undefined'){
                let saveUrl = saveLessonContentURL;
                let redirect = false;
                let content = {};
                if(component){
                    // console.log('save component')
                    content = readContainer(document.querySelector('.editor-body'), component);
                } else {
                    // console.log('save full lesson')
                    content = readContainer(document.querySelector('.editor-body'));
                }

                // console.log(content)
                // if(editorContent.closest('.editor-popup').classList.contains('save-new-lesson')){
                //     saveUrl = createLessonContentURL;
                //     redirect = true;
                // }
                // take lesson id from url
                let url = new URL(window.location.href);
                let lesson_id = url.searchParams.get("topic");
                // take lesson element
                //console.log(component)
                let lessonElement = document.querySelector('.custom-lesson[data-lesson="' + lesson_id + '"]');
                let module_id = lessonElement.closest('.custom-module-wrapper').id.substring(7);
                let is_autosave = component ? true : false;
                let component_id = component ? component : '';
                let json_content = JSON.stringify({'topic_id': lesson_id,'module_id': module_id, 'content': content, 'is_autosave': is_autosave, 'component_id': component_id});
                // console.log(json_content)
                fetch(saveUrl, {
                    method: 'POST',
                    body: json_content,
                    headers: {
                        'Charset': 'UTF-8',
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    }
                })
                    .then(
                        response => response.json()
                    )
                    .then(
                        response => {
                            // console.log(response);
                            document.querySelector('#editor-save-button').innerText = `${saved}!`;

                            setTimeout(() => {
                                document.querySelector('#editor-save-button').innerText = saveLesson;
                            }, 5000);
                            if(response.updated_images){
                                for (const key in response.updated_images) {
                                    if (response.updated_images.hasOwnProperty(key)) {
                                        const element = response.updated_images[key];
                                        let imageElement = document.querySelector('.editor-body [data-asset-id="' + key + '"]');
                                        if(imageElement){
                                            imageElement.src = element;
                                        }
                                    }
                                }
                            }

                            CGEditorTopic.updateLessonStatus(lesson_id);
                            CGEditorTopic.stopPreloader();
                        }
                    )
            } else {
                //console.log('saveLessonContentURL is not defined');
            }

        }
    }

    static updateLessonStatus(lessonID) {
        const lessonElement = document.querySelector('.custom-lesson[data-lesson="' + lessonID + '"]');
        const { preview, edit, remove, lessonBuilder } = l10n.customCourse;

        if(lessonElement){
            let tutorialTD = lessonElement.querySelector('.td-tutorial');
            lessonElement.dataset.rowTopicId = lessonID;
            lessonElement.dataset.rowTutorialType = '3'; // change when will be not only editor tutorial
            tutorialTD.innerHTML = `
                <div class="el-tutorial">
                    <button type="button" class="lesson-preview-btn">
                        <i class="icon icon-cgeditor"></i>
                        ${lessonBuilder}
                    </button>
                    <div class="lesson-type-controls">
                        <button class="run-lesson" data-type="tutorial" data-topic-id="${lessonID}" title="">
                            <i class="icon icon-eye"></i>
                            <span>${preview}</span>
                        </button>
                        <button class="edit-lesson-type-btn open-editor-article" data-tutorial-type="3" data-lesson="${lessonID}" data-value="cgeditor">
                            <i class="icon icon-edit"></i>
                            <span>${edit}</span>
                        </button>
                        <button class="delete-lesson-type-btn delete-tutorial" data-lesson="${lessonID}" data-value="cgeditor">
                            <i class="icon icon-delete"></i>
                            <span>${remove}</span>
                        </button>
                    </div>
                </div>
            `;
        }
    }

    static async getAssetsURLFromS3(params) {
        //console.log(params);
        let updatedParams = { ...params };

        const updateImageUrl = async (url) => {
            if (!url) return url;
            try {
                return await this.getURlFromS3(url);
            } catch (error) {
                console.error('Error updating image URL:', error);
                return url; // Return original URL in case of error
            }
        };

        switch (updatedParams['@section']) {
            case 'accordionSection':
                if (updatedParams.content.tabs) {
                    for (let item of updatedParams.content.tabs) {
                        item.image_url = await updateImageUrl(item.image_url);
                    }
                }
                // Note: Missing break in the original code might be intentional (fall-through), but adding it here for clarity
                break;
            case 'imageSection':
                updatedParams.content.image_url = await updateImageUrl(updatedParams.content.image_url);
                break;
            case 'labeledImageSection':
                updatedParams.content.image_url = await updateImageUrl(updatedParams.content.image_url);
                if (updatedParams.content.labels) {
                    for (let label of updatedParams.content.labels) {
                        label.image_url = await updateImageUrl(label.image_url);
                    }
                }
                break;
            case 'imageTextSection':
                updatedParams.content.image_url = await updateImageUrl(updatedParams.content.image_url);
                break;
            case 'tabsSection':
                if (updatedParams.content.tabs) {
                    for (let tab of updatedParams.content.tabs) {
                        if (tab.text) {
                            let images = tab.text.match(/<img[^>]+src="([^">]+)"/g);
                            if (images) {
                                for (let img of images) {
                                    let srcMatch = img.match(/src="([^">]+)"/);
                                    if (srcMatch) {
                                        let srcUrl = srcMatch[1];
                                        let newUrl = await updateImageUrl(srcUrl);
                                        tab.text = tab.text.replace(srcUrl, newUrl);
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case 'gallerySection':
                if (updatedParams.content.gallery) {
                    for (let img of updatedParams.content.gallery) {
                        img.src = await updateImageUrl(img.src);
                    }
                }
                break;
            case 'flashcardSection':
                if (updatedParams.content.flashcards) {
                    for (let card of updatedParams.content.flashcards) {
                        if (card.front.type === 'image') {
                            card.front.image = await updateImageUrl(card.front.image);
                        }
                        if (card.back.type === 'image') {
                            card.back.image = await updateImageUrl(card.back.image);
                        }
                    }
                }
                break;
            case 'tableSection':
                if (updatedParams.content.text) {
                    let images = updatedParams.content.text.match(/<img[^>]+src="([^">]+)"/g);
                    if (images) {
                        for (let img of images) {
                            let srcMatch = img.match(/src="([^">]+)"/);
                            if (srcMatch) {
                                let srcUrl = srcMatch[1];
                                let newUrl = await updateImageUrl(srcUrl);
                                updatedParams.content.text = updatedParams.content.text.replace(srcUrl, newUrl);
                            }
                        }
                    }
                }
                break;
            case 'listSection':
                if (updatedParams.content.list) {
                    for (let i = 0; i < updatedParams.content.list.length; i++) {
                        let images = updatedParams.content.list[i].match(/<img[^>]+src="([^">]+)"/g);
                        if (images) {
                            for (let img of images) {
                                let srcMatch = img.match(/src="([^">]+)"/);
                                if (srcMatch) {
                                    let srcUrl = srcMatch[1];
                                    let newUrl = await updateImageUrl(srcUrl);
                                    updatedParams.content.list[i] = updatedParams.content.list[i].replace(srcUrl, newUrl);
                                }
                            }
                        }
                    }
                }
                break;
            case 'videoSection':
                if (updatedParams.content.video_thumbnail) {
                    updatedParams.content.video_thumbnail_signed = await updateImageUrl(
                        this.stripCloudFrontUrl(updatedParams.content.video_thumbnail)
                    );
                    updatedParams.content.video_thumbnail = this.stripCloudFrontUrl(updatedParams.content.video_thumbnail);
                }
                if (updatedParams.content.video_url && updatedParams.content.video_type === 'upload') {
                    updatedParams.content.video_url_signed = await updateImageUrl(
                        this.stripCloudFrontUrl(updatedParams.content.video_url)
                    );
                    updatedParams.content.video_url = this.stripCloudFrontUrl(updatedParams.content.video_url);
                }
                break;
            default:
                // No action for the default case
                break;
        }

        return updatedParams;
    }

    /**
     * Strip signed CloudFront URL back to relative S3 path.
     * Handles both old data (full signed URLs) and new data (already relative paths).
     */
    static stripCloudFrontUrl(url) {
        if (!url) return url;
        if (url.indexOf('?') !== -1) {
            url = url.substring(0, url.indexOf('?'));
        }
        const domains = [
            'https://devcustomcontent.customguide.com/',
            'https://customcontent.customguide.com/',
        ];
        for (const domain of domains) {
            if (url.indexOf(domain) !== -1) {
                url = url.substring(url.indexOf(domain) + domain.length);
            }
        }
        return url;
    }

    /**
     * Asynchronously gets a URL from S3 or returns the original URL if it matches certain criteria.
     *
     * @param {string} url The URL to process.
     * @returns {Promise<string|boolean>} A promise that resolves to the processed URL or false if conditions are not met.
     */
    static async getURlFromS3(url) {
        //console.log(url)
        // If url contains '/editor/', it is considered custom content and returned directly.
        if (url.includes('/editor/')) {
            return url;
        }

        // Check if getCloudFrontContentURL is defined and is a variable
        if (!getCloudFrontContentURL || typeof getCloudFrontContentURL !== 'string') {
            console.error('getCloudFrontContentURL is not defined or is not a string.');
            return false;
        }

        const data = {
            path: url,
            isCustomContent: true,
        };

        try {
            const response = await fetch(getCloudFrontContentURL, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonResponse = await response.json();
            return jsonResponse.url; // This now waits for the fetch to complete.
        } catch (error) {
            console.error('Failed to fetch URL:', error);
            return false; // Return false or handle the error as needed.
        }
    }

    /**
     * Renders lesson content based on the given JSON string.
     * @param {string} content - JSON string representing the lesson content.
     */
    static async renderLessonContent(content) {
        const editorWorkplace = document.querySelector('.editor-workplace');
        //console.log(content)
        // Early return if json is empty
        if (!content) {
            editorWorkplace.innerHTML = '';
            return;
        }

        try {
            const jsonContent = typeof content === 'object' ? content : JSON.parse(content);
            let html = '';

            // Assuming that getAssetsURLFromS3 updates the entire section including nested URLs
            for (const [key, section] of Object.entries(jsonContent)) {
                // Process each section with getAssetsURLFromS3 to update URLs
                const updatedSection = await this.getAssetsURLFromS3(section);

                // Now use the updated section with URLs processed
                const component = new EditorComponentsRendering(updatedSection['@section'], updatedSection, true);
                html += await component.run();
            }

            editorWorkplace.innerHTML = html;
            this.finalizeRendering();
        } catch (error) {
            console.error('Error parsing or processing lesson content:', error);
        }
    }

    static finalizeRendering() {
        // Hide the first button if jsonContent exists
        const firstButton = document.querySelector('.btn-add-first');
        if (firstButton) {
            firstButton.classList.add('hidden');
        }

        // Additional UI adjustments after rendering content
        document.body.classList.remove('loading');
        setTimeout(() => FroalaInit(), 100);
        this.stopPreloader(); // Stop the preloader
        //console.log('Content rendered');
        // Dispatch an event to signal that the content has been rendered
        const event = new CustomEvent('existingArticleRendered');
        document.dispatchEvent(event);
    }

}
